export const sizeClasses = {
  small: 'px-4 py-1.5',
  medium: 'px-6 py-2.5',
  large: 'px-6 py-3',
  smallIcon: 'p-1.5',
  mediumIcon: 'p-2',
  largeIcon: 'p-2.5'
};
